import * as React from 'react';

const ElectronicsBadgeMultichrome32 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1EAE1",
    d: "M32 16c0 8.836-7.163 16-16 16S0 24.836 0 16 7.164 0 16 0s16 7.163 16 16"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M19.361 8.636a1.5 1.5 0 0 1-1.06-.44l-1.254-1.254a1.5 1.5 0 0 0-2.12 0l-1.255 1.255a1.5 1.5 0 0 1-1.06.439h-2.28a1.5 1.5 0 0 0-1.5 1.5v2.279a1.5 1.5 0 0 1-.44 1.061l-1.466 1.466a1.5 1.5 0 0 0 0 2.122l1.466 1.466c.282.281.44.663.44 1.061v1.861a1.5 1.5 0 0 0 1.5 1.5h1.863a1.5 1.5 0 0 1 1.06.44l1.672 1.672a1.5 1.5 0 0 0 2.12 0l1.672-1.672a1.5 1.5 0 0 1 1.06-.44h1.864a1.5 1.5 0 0 0 1.499-1.5v-1.86c0-.4.158-.78.44-1.062l1.465-1.466a1.5 1.5 0 0 0 0-2.122l-1.465-1.466a1.5 1.5 0 0 1-.44-1.061v-2.279a1.5 1.5 0 0 0-1.5-1.5z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#fff",
    d: "M16 15.6a.75.75 0 0 0 .75-.75v-3a.75.75 0 1 0-1.5 0v3c0 .414.336.75.75.75"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#fff",
    d: "M11.25 15.85c0-1.202.446-2.299 1.182-3.136.274-.312.755-.263 1.02.06.26.319.206.785-.043 1.113a3.25 3.25 0 1 0 5.182 0c-.25-.328-.303-.794-.042-1.114.264-.322.745-.371 1.02-.059a4.75 4.75 0 1 1-8.319 3.135Z"
  }
));
ElectronicsBadgeMultichrome32.Size = 32;
ElectronicsBadgeMultichrome32.Title = "ElectronicsBadgeMultichrome";

export { ElectronicsBadgeMultichrome32 as default };
